import React, { Children, useId, useLayoutEffect, useRef, useState } from 'react'
import { Box, Link } from '@mui/material'
import { rbacAssignedItemsSx } from './constants/rbacAssignedDataDetailConstants'

export default function RbacAssignedItemsList({ children, loading }) {
  const id = useId()
  const listRef = useRef(null)
  const [expanded, setExpanded] = useState(false)
  const [layout, setLayout] = useState({ visibleCount: Infinity, height: undefined })
  const items = Children.toArray(children)

  useLayoutEffect(() => {
    const list = listRef.current
    const measure = () => {
      const origin = list.getBoundingClientRect().top
      let rowTop = null
      let rows = 0
      let visibleCount = 0
      let height = 0

      Array.from(list.children).forEach((item) => {
        const bounds = item.getBoundingClientRect()
        if (rowTop === null || Math.abs(bounds.top - rowTop) > 1) {
          rowTop = bounds.top
          rows += 1
        }
        if (rows <= 3) {
          visibleCount += 1
          height = Math.max(height, bounds.bottom - origin)
        }
      })

      setLayout((previous) =>
        previous.visibleCount === visibleCount && previous.height === height
          ? previous
          : { visibleCount, height }
      )
    }

    measure()
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure)
    observer?.observe(list)
    window.addEventListener('resize', measure)
    return () => {
      observer?.disconnect()
      window.removeEventListener('resize', measure)
    }
  }, [children])

  const hasMore = layout.visibleCount < items.length

  return (
    <>
      <Box sx={{ ...rbacAssignedItemsSx, display: 'block' }} aria-busy={loading}>
        <Box id={id} sx={{ overflow: 'hidden', maxHeight: expanded ? undefined : layout.height }}>
          <Box
            ref={listRef}
            sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'flex-start' }}
          >
            {items.map((item, index) => {
              const hidden = !expanded && index >= layout.visibleCount
              return (
                <Box
                  key={item.key}
                  aria-hidden={hidden || undefined}
                  inert={hidden || undefined}
                  sx={{
                    display: 'inline-flex',
                    maxWidth: '100%',
                    visibility: hidden ? 'hidden' : 'visible'
                  }}
                >
                  {item}
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
      {!loading && hasMore && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
          <Link
            component="button"
            type="button"
            aria-expanded={expanded}
            aria-controls={id}
            onClick={() => setExpanded((value) => !value)}
            sx={{
              color: '#1E40AF',
              fontSize: 12,
              fontWeight: 500,
              lineHeight: 1.2,
              p: 0,
              minWidth: 0
            }}
          >
            {expanded ? 'Ver menos' : 'Ver más...'}
          </Link>
        </Box>
      )}
    </>
  )
}
